import { useState } from 'react';
import { message } from 'antd';
import { API_BASE_URL } from '../config';

export const usePublishCard = ({ userInfo, onSubmit }) => {
  const [submitting, setSubmitting] = useState(false);

  // 发送钉钉卡片
  const sendDingTalkCard = async ( syncToChat, cardData) => {
    try {
      // 如果没有选择群聊，直接返回成功
      if (!syncToChat || !cardData.selectedChats || cardData.selectedChats.length === 0) {
        console.log('没有选择群聊，直接返回成功', cardData, syncToChat);
        return { success: true };
      }
      // 发送请求到后端API
      const response = await fetch(`${API_BASE_URL}/dingtalk/send-card`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content: cardData.content,
          title: cardData.title,
          selectedChats: cardData.selectedChats,
          userId: userInfo.userId,  
          likeCount: "2",
          commentCount: "2",
          name: userInfo.name,
          avatar: userInfo.avatar,
        })
      });
      
      const result = await response.json();
      console.log('发送钉钉卡片响应:', result.results);
      const data =result.results[0];
      console.log('发送钉钉卡片响应2:', data);
      if (data.success) {
        console.log('发送钉钉卡片成功:', data.response.result);
        const outTrackId = data.response.result.outTrackId;
        return { 
          success: true, 
          results: data.response.result,
          outTrackId: outTrackId
        };
      } else {
        console.log('发送钉钉卡片失败:', data.message);
        return { 
          success: false, 
          message: data.message 
        };
      }
    } catch (error) {
      console.error('发送钉钉卡片错误:', error);
      return { 
        success: false, 
        message: error.message 
      };
    }
  };

  // 处理表单提交
  const handleFinish = async (values, selectedChats, form) => {
    if (!values.content.trim()) {
      message.warning('内容不能为空');
      return;
    }

    if (values.syncToChat && selectedChats.length === 0) {
      message.warning('请至少选择一个群聊');
      return;
    }

    setSubmitting(true);
    
    try {
      const cardData = {
        content: values.content,
        title: values.title,
        selectedChats: values.syncToChat ? selectedChats : []
      };

      const result = await sendDingTalkCard( values.syncToChat, cardData);
      console.log('发送结果:', result);

      if (result.success) {
        message.success('钉钉卡片发布成功');
        onSubmit(values.content, values.title, values.syncToChat, values.selectedValuesall, values.selectedUsers, result.outTrackId);
        form.resetFields();
        return { success: true, resetChats: true };
      } else {
        message.error('发布失败: ' + result.message);
        return { success: false };
      }
    } catch (error) {
      console.error('发布钉钉卡片错误:', error);
      message.error('发布失败，请稍后重试');
      return { success: false };
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    setSubmitting,
    handleFinish,
    sendDingTalkCard
  };
};